<script setup lang="ts">
/**
 * Il marchio GissiLab, per chi lavora a Gissi (Cosimo, 2026-10-23: *«per gli utenti di Gissi
 * mettimici il logo di Gissi»*). Lo stesso file dell'app (`packages/brand/assets/gissilab-lockup.svg`,
 * vedi `LEGGIMI-gissilab.md`): vettoriale, un colore solo su `currentColor`, quindi segue il
 * colore del testo e si inverte da sé in tema scuro — «LAB» è un buco, non una scritta bianca.
 *
 * Più semplice di `BesteLogo`: il file non dichiara identificatori (`id=`), quindi due istanze
 * nella stessa pagina non si rubano le maschere, e c'è una variante sola — un simbolo da solo
 * GissiLab non ce l'ha.
 */
import { computed } from 'vue';

import gissilabRaw from '@bestehr/brand/assets/gissilab-lockup.svg?raw';

/** Misurato sul file: 340,16 × 78,74 pt (lo stesso `RAPPORTO_GISSILAB` dell'app). */
const RAPPORTO = 340.1579 / 78.742679;

const props = withDefaults(
  defineProps<{
    /** Altezza di disegno, in pixel CSS. */
    height?: number;
    /** Il nome accessibile; assente, il marchio è decorativo (come in `BesteLogo`). */
    title?: string;
  }>(),
  { height: 32, title: undefined },
);

const larghezza = computed(() => Math.round(props.height * RAPPORTO));
</script>

<template>
  <!-- `v-html` su un file del nostro pacchetto marchio, importato a compilazione: niente di scritto da fuori. -->
  <!-- eslint-disable vue/no-v-html -->
  <span
    class="logo"
    :style="{ width: `${larghezza}px`, height: `${height}px` }"
    :role="title ? 'img' : undefined"
    :aria-label="title"
    :aria-hidden="title ? undefined : 'true'"
    v-html="gissilabRaw"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<style scoped>
.logo {
  display: inline-block;
  flex: none;
  line-height: 0;
  color: inherit;
}

.logo :deep(svg) {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
